<template>
  <div
    ref="departureTable"
    :class="{ 'mb-12 pt-2': mainTab }"
  >
    <h4
      v-if="!trip.hasDepartures && !loading"
      class="text-center py-12 text-slate-500 font-normal print-hidden"
    >
      <span data-i18n="tripPage.departures.noDepartures">
        {{ $t('tripPage.departures.noDepartures') }}&nbsp;
      </span>
      <span>
        {{ trip.title }}
      </span>
    </h4>
    <template v-else>
      <Loading v-if="loading" />
      <template v-else>
        <LazyDealFinder
          v-if="trip.calendar_type === 'calendar'"
          :display-title="false"
          class="-mx-2 md:mx-0 print-hidden"
          emit-selection
          :display-months="false"
          @select="onSelectDay"
        >
          <template #calendar="{ dates, isLoading, hasError }">
            <DeparturesCalendar
              class="-mx-4 sm:mx-0"
              :trips="dates"
              :loading="isLoading"
              :disabled="hasError"
            />
          </template>
        </LazyDealFinder>

        <LazyTripDepartures
          v-else
          :calendar="calendar"
          :flight-trip="flightTrip"
          :show-seats-left="showSeatsLeft"
          :main-tab="mainTab"
        />
      </template>
    </template>
  </div>
</template>

<script>
import { mapState } from 'pinia'
import scrollMixin from '@packages/scroll/mixins/scroll.mixin.js'

export default defineNuxtComponent({
  setup () {
    const { urls: localeURLs } = useLocale()

    return {
      localeURLs,
    }
  },

  mixins: [scrollMixin],

  props: {
    calendar: {
      type: Object,
      required: true,
    },

    flightTrip: {
      type: Boolean,
      default: false,
    },

    mainTab: {
      type: Boolean,
      default: true,
    },

    showSeatsLeft: {
      type: Boolean,
      default: true,
    },

    loading: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapState(useTripStore, {
      trip: 'trip',
    }),

    ...mapState(useCharterStore, {
      destination: 'destination',
    }),

    ...mapState(useCharterPackagesStore, ['durations', 'packages']),
    ...mapState(useRootStore, ['charterAirports']),

    containerClass () {
      const classes = []

      if (!this.mainTab) {
        classes.push('mt-6')
      }

      if (this.trip.calendar_type === 'calendar') {
        classes.push('pt-6 rounded-lg')
      } else {
        classes.push('px-0 pt-0')
      }

      return classes.join(' ')
    },
  },

  mounted () {
    if (!this.mainTab && this.$route.query.top !== undefined) {
      this.scrollTo(this.$refs.departureTable)
    }
  },

  methods: {
    onSelectDay (day) {
      const url = `${this.localeURLs.book}/${day?.tripid}?price=${day?.price}`

      if (!day?.tripid) {
        this.$sentryCaptureException('rolfs/dealfinder/no tripid', {
          level: 'error',
          extra: {
            details: JSON.stringify({
              day,
              url,
            }),
          },
          tags: {
            type: 'UX',
            source: 'booking',
          },
        })
      }

      this.$router.push(url).catch(() => {})
    },
  },
})
</script>
